<template>
  <th scope="col" class="slds-is-sortable" :class="isColumnSorted">
    <a
      class="slds-th__action slds-text-link_reset"
      @click="sortCol(`${columnKey}`, `${columnType}`)"
      role="button"
      tabindex="-1"
    >
      <!--<a class="slds-th__action slds-text-link_reset" @click="sortCol(`${columnKey}`, `${columnType}`)" role="button" tabindex="-1">-->
      <div
        class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate"
      >
        <span :title="`${text}`">{{ text }}</span>
        <template v-if="sortable">
          <template v-if="sortDirection == 'descending'">
            <span class="slds-icon_container slds-icon-utility-arrowdown">
              <svg
                class="slds-icon slds-icon-text-default slds-is-sortable__icon"
                aria-hidden="true"
              >
                <use
                  xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowdown"
                ></use>
              </svg>
            </span>
          </template>
          <template v-else>
            <span class="slds-icon_container slds-icon-utility-arrowup">
              <svg
                class="slds-icon slds-icon-text-default slds-is-sortable__icon"
                aria-hidden="true"
              >
                <use
                  xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowup"
                ></use>
              </svg>
            </span>
          </template>
        </template>
      </div>
    </a>
  </th>
</template>
<script>
export default {
  name: "TableHeadRow",
  props: {
    text: {
      type: String,
      default: "",
    },
    columnKey: {
      type: String,
      default: "",
    },
    columnType: {
      type: String,
      default: "",
    },
    sortable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sortDirection: "descending",
      isSorted: false,
    };
  },
  methods: {
    isColumnSorted: function() {
      return this.isSorted ? "slds-is-sorted" : false;
    },
    tableSortStatus(status) {
      this.$emit("tableSortStatus", status);
    },
    sortCol: function(col, type) {
      this.$parent.sortTableCol(col, type);
    },
    filterCol: function(col, type) {
      this.$parent.sortTableCol(col, type);
    },
  },
};
</script>
